import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: "What if I'm too tired to even start?",
  a: "That's exactly why the '10-Minute Mode' exists. You don't need to do it all. Just pick one small piece. The system is designed to be picked up and put down without losing your place."
}, {
  q: 'Does this replace a Support Coordinator?',
  a: "No. This gives you the clarity and structure to make better decisions and communicate effectively with your coordinator (or manage yourself if you don't have one)."
}, {
  q: "What if my child's needs are different?",
  a: "The system is about decision-making and organization, not 'perfect cases'. It adapts to your specific situation because it provides the framework, you provide the details."
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-20 bg-cream-50" data-id="element-15">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-3xl" data-id="element-16">
        <h2 className="font-serif text-3xl font-bold text-navy-900 mb-12 text-center" data-id="element-17">
          Common Questions
        </h2>

        <div className="space-y-4" data-id="element-18">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-xl shadow-sm overflow-hidden" data-id="element-19">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-4 text-left flex items-center justify-between focus:outline-none" data-id="element-20">
                <span className="font-medium text-navy-900 text-lg" data-id="element-21">
                  {faq.q}
                </span>
                <ChevronDown className={`h-5 w-5 text-gray-400 transition-transform duration-300 ${openIndex === index ? 'transform rotate-180' : ''}`} data-id="element-22" />
              </button>
              <AnimatePresence data-id="element-23">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-24">
                    <div className="px-6 pb-6 text-gray-600 leading-relaxed" data-id="element-25">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}